export const genderOpt = [
    { value: "_", label: "Semua" },
    { value: "L", label: "Putra" },
    { value: "P", label: "Putri" },
]
export const milikOpt = [
    { value: "L", label: "Putra" },
    { value: "P", label: "Putri" },
]